import React, { FC } from 'react';
import styles from './spinning-loader.module.scss';

interface ISpinningLoaderProps {
  height: string;
  width: string;
  color?: string;
}

const SpinningLoader: FC<ISpinningLoaderProps> = ({
  height,
  width,
  color = '#d63426',
}) => (
  <div className={styles.container} style={{ height, width, color }}>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);

export default SpinningLoader;
